/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {formatMask} from '../../../../../utils/formatMonetaryToBr'
import {BudgetResponse} from '../../../../../coreGlobal/models/budgets/budget'
import {IconIsActive} from '../../../../../components/IconIsActive'

type Props = {
  budget: BudgetResponse
}

const FranchiseNameCell: FC<Props> = ({budget}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span role='button'>{budget.franchise?.name}</span>
      </div>
    </div>
  )
}

const ClientNameCell: FC<Props> = ({budget}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span role='button'>
          {budget.client?.activeAlert && (
            <IconIsActive text={budget.client?.alerts?.[0]?.observation} />
          )}
          {budget.client?.name}
        </span>
      </div>
    </div>
  )
}

const ClientDocumentCell: FC<Props> = ({budget}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span role='button'>{budget.client?.physicalPerson?.document}</span>
      </div>
    </div>
  )
}

const PriceCell: FC<Props> = ({budget}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span role='button'>{formatMask(budget.price)}</span>
      </div>
    </div>
  )
}

const ReviewStatusCell: FC<Props> = ({budget}) => {
    if (!budget.discountReviewStatus)
        return <></>

    let badgeClass = ''
    switch (budget.discountReviewStatus) {
        case 'pending':
            badgeClass = 'primary'
            break
        case 'approved':
            badgeClass = 'success'
            break
        case 'rejected':
            badgeClass = 'danger'
            break
        default:
            badgeClass = 'secondary'
            break
    }
    return (
        <div className='d-flex flex-column'>
            <div className='gap-1'>
                <span className={`badge badge-${badgeClass}`}>{budget.i18nDiscountReviewStatus}</span>
            </div>
        </div>
    )
}

export {FranchiseNameCell, ClientNameCell, ClientDocumentCell, PriceCell, ReviewStatusCell}
